/**
 * Client kết nối Backend API truyền rõ mã nguồn adapter
 */
import { DEFAULT_SOURCE } from '../config/constants.js';

export class ApiClient {
  /**
   * Tìm kiếm truyện theo từ khóa và mã nguồn adapter
   * @param {string} keyword 
   * @param {string} source Mã adapter (mặc định 's1')
   */
  static async searchStories(keyword, source = DEFAULT_SOURCE) {
    const res = await fetch(`/api/search?q=${encodeURIComponent(keyword)}&source=${encodeURIComponent(source)}`);
    return await res.json();
  }

  /**
   * Lấy chi tiết truyện và danh sách chương từ đúng adapter
   * @param {string} storyId 
   * @param {string} source 
   */
  static async getStoryDetail(storyId, source = DEFAULT_SOURCE) {
    const res = await fetch(`/api/story?story=${encodeURIComponent(storyId)}&source=${encodeURIComponent(source)}`);
    return await res.json();
  }

  /**
   * Lấy nội dung chương truyện đã làm sạch từ đúng adapter
   * @param {string} storyId 
   * @param {string} chapterId 
   * @param {string} source 
   */
  static async getChapterContent(storyId, chapterId, source = DEFAULT_SOURCE) {
    const res = await fetch(`/api/chapter?story=${encodeURIComponent(storyId)}&chapter=${encodeURIComponent(chapterId)}&source=${encodeURIComponent(source)}`);
    return await res.json();
  }
}
